import type { ReactNode } from 'react';
import { cn } from '../../lib/cn';

type Props = {
  titolo?: string;
  /** Una o due righe sotto il titolo: a cosa serve il riquadro. */
  sotto?: ReactNode;
  /** Pulsanti o comandi a destra del titolo. */
  azioni?: ReactNode;
  children: ReactNode;
  className?: string;
  /** Classi del contenuto, es. 'p-0' per un elenco che arriva ai bordi. */
  corpo?: string;
};

/**
 * Il riquadro bianco delle pagine degli eventi: bordo sottile e ombra
 * leggera, cosi' la pagina resta ariosa anche con molti riquadri uno sotto
 * l'altro.
 */
export function Pannello({ titolo, sotto, azioni, children, className, corpo }: Props) {
  return (
    <section className={cn('rounded-xl border border-gray-200 bg-white shadow-sm', className)}>
      {(titolo || azioni) && (
        <header className="flex flex-col gap-3 px-4 pt-4 md:px-5 md:pt-5 lg:flex-row lg:items-start lg:justify-between">
          <div className="min-w-0">
            {titolo && <h2 className="text-base font-semibold text-gray-900">{titolo}</h2>}
            {sotto && <p className="text-xs text-neutral-500 mt-1 leading-relaxed max-w-2xl">{sotto}</p>}
          </div>
          {azioni && <div className="flex flex-wrap items-center gap-2 flex-shrink-0">{azioni}</div>}
        </header>
      )}
      <div className={cn('p-4 md:p-5', corpo)}>{children}</div>
    </section>
  );
}
